import type { CSSProperties } from 'react'
import type { ThumbCrop } from 'stores/cartStore/CartItem'

// Builds the inline style that maps a relative (0-1) crop onto its container.
// Kept off the styled-component so the continuous crop values don't generate a
// new runtime class per thumbnail.
export function getCropStyle(crop: ThumbCrop): CSSProperties {
  return {
    width: `${100 / crop.widthRatio}%`,
    height: `${100 / crop.heightRatio}%`,
    transform: `translate(${-crop.xRatio * 100}%, ${-crop.yRatio * 100}%)`,
  }
}
